import { render } from "./CameraLabels.vue?vue&type=template&id=23e2138a&ts=true"
import script from "./CameraLabels.vue?vue&type=script&lang=ts"
export * from "./CameraLabels.vue?vue&type=script&lang=ts"

import "./CameraLabels.vue?vue&type=style&index=0&id=23e2138a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__